import React from 'react';
import {
  Box,
  Button,
  Link,
  List,
  ListItem,
  Stack,
  Typography,
  Grid,
} from '@mui/material';

// MESSAGES
import BulkSendFormattedMessages from '../../../messages/websms/BulkSendFormattedMessages';

// COMPONENTS
import SectionWrapper from '../../common/SectionWrapper';

export default function BulkSendGuide({ handleHideMessage }) {
  return (
    <Grid container sx={{ justifyContent: 'space-between' }}>
      <Grid size={{ xs: 12, lg: 7, xl: 8 }}>
        <Grid container sx={{ gap: 4 }}>
          <Grid size={12}>
            <SectionWrapper
              title="Formatting Your Bulk Send List"
              icon="bulkSend"
            >
              <Typography>
                {BulkSendFormattedMessages.landingFormattingText} (
                {BulkSendFormattedMessages.exampleCSV}
                <Link href="/static/example_bulk_import.csv" download>
                  {BulkSendFormattedMessages.exampleCSVLink}
                </Link>
                )
              </Typography>

              <List
                sx={{
                  listStyleType: 'disc',
                  paddingLeft: 2,
                  '& .MuiListItem-root': {
                    display: 'list-item',
                    padding: 0,
                  },
                }}
              >
                <ListItem>
                  {BulkSendFormattedMessages.landingFormattingListItem1}
                </ListItem>
                <ListItem>
                  {BulkSendFormattedMessages.landingFormattingListItem2}
                </ListItem>
                <ListItem>
                  {BulkSendFormattedMessages.landingFormattingListItem3}
                </ListItem>
                <ListItem>
                  {BulkSendFormattedMessages.landingFormattingListItem4}
                </ListItem>
              </List>
            </SectionWrapper>
          </Grid>

          <Grid size={12}>
            <SectionWrapper
              title="Building a Template for Bulk Sends"
              icon="messages"
            >
              <Typography gutterBottom>
                {BulkSendFormattedMessages.landingText1}
              </Typography>

              <Typography gutterBottom>
                {BulkSendFormattedMessages.landingText2}
              </Typography>

              <Typography>{BulkSendFormattedMessages.landingText3}</Typography>

              <Typography fontWeight={700} gutterBottom sx={{ marginLeft: 4 }}>
                {BulkSendFormattedMessages.landingText4}
              </Typography>

              <Typography> {BulkSendFormattedMessages.landingText5}</Typography>

              <Typography fontWeight={700} gutterBottom sx={{ marginLeft: 4 }}>
                {BulkSendFormattedMessages.landingText6}
              </Typography>

              <Box
                sx={{
                  marginBottom: 6,
                  '& img': {
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                  },
                }}
              >
                <img
                  src="/static/sample_csv_image_2.png"
                  alt="Example of csv file."
                  width="240"
                  height="83"
                />
              </Box>

              <Typography fontWeight={700} gutterBottom>
                {BulkSendFormattedMessages.optionalMethod}
              </Typography>

              <Typography gutterBottom>
                {BulkSendFormattedMessages.optionalMethodText}
              </Typography>

              <Box
                sx={{
                  marginBottom: 2,
                  '& img': {
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                  },
                }}
              >
                <img
                  src="/static/sample_csv_image.png"
                  alt="Example of csv file with message."
                  width="598"
                  height="249"
                />
              </Box>
            </SectionWrapper>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        size={{ xs: 12, lg: 4.5, xl: 3.5 }}
        sx={{ paddingX: { xs: 4, lg: 0 }, paddingY: { xs: 2.5, lg: 0 } }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
            justifyContent: { lg: 'center' },
            alignItems: 'flex-end',
            flex: 1,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleHideMessage({ hideMessage: true })}
          >
            Don&rsquo;t show again
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleHideMessage({ hideMessage: false })}
          >
            Skip
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
